<template>
  <div class="users-body" v-if="loading">
    {{isLoading}}
    <Loader />
  </div>
  <div class="su-content su-subscribes-content" v-else>
    <div class="cards-list c-products__list js-masonry" v-if="getUserSubscribes.length">
      <Card v-for="product, idx in getUserSubscribes" :key="idx" :product="product" />
    </div>
    <div class="su-empty su-about-empty" v-else>
      <EmptyBlock />
    </div>
  </div>
</template>

<script>
  import Card from '@/components/Cards/ProductCard.vue'
  import EmptyBlock from '@/components/Empty.vue'
  import Loader from '@/components/Loader.vue'

  export default {
    components: {
      EmptyBlock,
      Card,
      Loader,
    },
    data() {
      return {
        loading: true,
      }
    },
    created() {
      let subscrInfo = {
        userId: this.$route.params.id,
        type: 'product',
        search: '',
      }
      this.$store.dispatch('uploadUserSubscribes', subscrInfo)
    },
    computed: {
      isLoading() {
        this.getUserSubscribes
      },
      getUserSubscribes() {
        let subscribes = this.$store.getters.getUserSubscribeProduct
        this.$store.dispatch('pageTitle', 'Подписки')
        if (subscribes) {
          this.loading = false
        }
        return subscribes
      }
    }

  }
</script>

<style lang="scss" scoped>

</style>